export default "__VITE_ASSET__BUnrLzzE__"